// extracted by mini-css-extract-plugin
export var label = "_em-5";
export var slideContainer = "_em-0";
export var slider = "_em-1";
export var sliderLg = "_em-4";
export var sliderMd = "_em-3";
export var sliderSm = "_em-2";